/* eslint-disable */
<template>
  <div>
    <div class="bookings-tentative">
      <AdminNavigation v-if="user.type >= 3" ref="navigation" indexProps="5"/>
      <Navigation v-else ref="navigation" indexProps="2"/>
      <div class="top-panel">
        <Header/>
        <div class="header-title-section">
          <div class="header-title"><h1>Tentative Bookings</h1></div>
          <div class="header-sub-title">The following bookings have a Tentative status.</div>
        </div>
      </div>
      <div class="panel">
        <AdminBookingsMenu v-if="user.type >= 3" indexProps="6"/>
        <ClientBookingMenu v-else indexProps="5"/>
        <div class="content">
          <div class="row">
            <div class="col pt-0 pl-0">Total Tentative Bookings: {{totalCount }}</div>
            <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Specialist Name" v-model="listParam.SpecialistName"/>
            <el-input v-if="user.type >= 3" style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Client Name" v-model="listParam.ClientName"/>
            <el-input v-if="user.type >= 3" style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Contact Name" v-model="listParam.ContactName"/>
            <el-date-picker
                style="width: 260px"
                v-model="dateValue"
                type="daterange"
                start-placeholder="Start Date"
                popper-class="date-range-picker-popper"
                value-format="yyyy-MM-dd"
                format="dd/MM/yyyy"
                @change="changeDates"
                end-placeholder="End Date"
                clearable
            />
          </div>

          <div class="content-scroll-x">
            <div>
              <el-table :default-sort="{prop: 'TentativePreBookingID', order: 'descending'}" :data="bookings" stripe @sort-change="sortParam" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
                <el-table-column
                    width="80"
                    show-overflow-tooltip
                    label="ID"
                    sortable="custom"
                    prop="TentativePreBookingID"
                >
                </el-table-column>
                <el-table-column
                    v-if="user.type >= 3"
                    width="150"
                    show-overflow-tooltip
                    prop="Client"
                    sortable="custom"
                    label="Client"
                >
                  <template slot-scope="booking">
                    <span>{{booking.row.Client && decodeURIComponent(booking.row.Client.ClientName)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="user.type < 3"
                    width="150"
                    show-overflow-tooltip
                    label="Branch Name"
                    prop="BranchName"
                >
                  <template slot-scope="booking">
                    <span>{{decodeURIComponent(booking.row.Client.BranchName)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    label="Contact"
                    sortable="custom"
                    prop="ClientContact"
                >
                  <template slot-scope="booking">
                    <router-link v-if="user.type >= 3"
                        :to="{ name: 'admin-manage-client', query: { id: booking.row.Client.ClientID }}">
                      <span>{{ booking.row.ClientContact && decodeURIComponent(booking.row.ClientContact.FirstName + ' ' + (booking.row.ClientContact.MiddleName ? booking.row.ClientContact.MiddleName + ' ' : '') + booking.row.ClientContact.Surname)}}</span>
                    </router-link>
                    <span v-else>{{ booking.row.ClientContact && decodeURIComponent(booking.row.ClientContact.FirstName + ' ' + ( booking.row.ClientContact.MiddleName ? booking.row.ClientContact.MiddleName + ' ' : '') + booking.row.ClientContact.Surname)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    prop="Client"
                    label="Phone/Email"
                >
                  <template slot-scope="booking">
                    <span>{{booking.row.ClientContact && booking.row.ClientContact.Mobile + ' / ' + booking.row.ClientContact.EmailAddress}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    sortable="custom"
                    label="Examinee"
                    prop="Claimant"
                >
                  <template slot-scope="booking">
                    <span>{{decodeURIComponent(booking.row.ClaimantFirstName + ' ' + booking.row.ClaimantSurname)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    show-overflow-tooltip
                    label="RHAdmin Username"
                    prop="CreatedByName"
                >
                  <template slot-scope="booking">
                    <span>{{decodeURIComponent(booking.row.UsernameLog)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    label="Date Submitted"
                    prop="DateSubmitted"
                >
                  <template slot-scope="booking">
                      <span>{{
                          formatDate(booking.row.DateSubmitted, 'DD/MM/YYYY hh:ss A', 'YYYY-MM-DD HH:mm:ss.ssssss')
                        }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    label="Specialist"
                    prop="Specialist"
                    sortable="custom"
                >
                  <template slot-scope="booking">
                    <span>{{booking.row.Specialist && decodeURIComponent(booking.row.Specialist.Title + ' ' + booking.row.Specialist.FirstName + ' ' + booking.row.Specialist.Surname)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    label="Location"
                    prop="Location"
                >
                  <template slot-scope="booking">
                    <span>{{ booking.row.Availability && booking.row.Availability.Location && decodeURIComponent(booking.row.Availability.Location.LocationName) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    label="Booking Date"
                    prop="BookingDate"
                    sortable="custom"
                >
                  <template slot-scope="booking">
                    <span>{{
                        formatDate(booking.row.BookingDate, 'DD/MM/YYYY', 'YYYY-MM-DD HH:mm:ss.ssssss')
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    sortable="custom"
                    show-overflow-tooltip
                    label="Expired Time"
                    prop="ExpiredTime"
                >
                  <template slot-scope="booking">
                    <span>{{
                        formatDate(booking.row.ExpiredTime, 'DD/MM/YYYY HH:mm', 'YYYY-MM-DD HH:mm:ss.ssssss')
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    label="Booking Status"
                    prop="Status"
                >
                  <template slot-scope="booking">
                    <span>{{
                        getStatus(booking.row.Status)
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="270"
                    fixed="right"
                    show-overflow-tooltip
                    label="Actions"
                >
                  <template slot-scope="booking">
                    <el-button @click="toBook(booking.row)" type="primary" size="mini">Book</el-button>
                    <el-button v-if="user.type >= 3" @click="extendBooking(booking.row)" size="mini" type="info">Extend</el-button>
                    <el-popconfirm
                        title="Are you sure you wish to release it？"
                        @confirm="releaseBooking(booking.row)"
                    >
                      <el-button class="ml-2" size="mini" slot="reference">Release</el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div v-if="totalCount > listParam.pageSize" class="pagination">
            Page
            <div class="pagination-group">
              <div class="border-icon pagination-current dropdown">
                <div class="pagination-current-text">{{ listParam.pageNum }}</div>
                <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                     aria-expanded="false"></div>
                <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                  <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                       :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
            <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from "@/assets/js/utilities"
import AdminNavigation from "@/components/AdminNavigation"
import AdminBookingsMenu from "@/components/AdminBookingsMenu"
import Header from "@/components/Header"
import { debounce } from 'lodash';
import Navigation from "@/components/Navigation";
import ClientBookingMenu from "@/components/ClientBookingMenu";

export default {
  name: "AdminBookingsTentative",
  components: {
    ClientBookingMenu,
    Navigation,
    AdminNavigation,
    AdminBookingsMenu,
    Header,
  },
  data() {
    return {
      dateValue: '',
      bookings: [],
      allBookings: [],
      limit: 10,
      pagination: utilities.initPagination(),
      totalCount: 0,
      listParam: {
        pageSize: 10,
        pageNum: 1,
        orderBy: 'TentativePreBookingID',
        ascOrDesc: 'DESC',
        ClientName: '',
        SpecialistName: '',
        ContactName: '',
        BookingDateFrom: null,
        BookingDateTo: null
      },
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    async releaseBooking(item) {
      await this.$store.dispatch('loading/setLoadComponent', true)
      const param = {
        Status: 2
      }
      await utilities.putTentativeBooking(item.TentativePreBookingID, param)
      await this.$store.dispatch('loading/setLoadComponent', false)
      this.selectPage(1)
    },
    extendBooking(item) {
      this.$confirm({
        content: 'Are you sure you want to extend this Tentative Booking?',
        onConfirm: async () => {
          await this.$store.dispatch('loading/setLoadComponent', true)
          const param = {
            Status: 4,
          }
          await utilities.putTentativeBooking(item.TentativePreBookingID, param)
          await this.$store.dispatch('loading/setLoadComponent', false)
          this.selectPage(1)
        }
      })
    },
    toBook(item) {
      const bookingParams = {
        id: item.Specialist.SpecialistID,
        tentativeBookingID: item.TentativePreBookingID,
        typeId: item.BookingType.BookingTypeID,
        waitlisted: false,
        caseOwner: item.ClientContact.ClientContactID,
        claimantFirstName: decodeURIComponent(item.ClaimantFirstName),
        claimantSurname: decodeURIComponent(item.ClaimantSurname),
        clientId: item.Client?.ClientID,
        DateofBirth: window.moment(item.DateofBirth).format('yyyy-MM-DD'),
        endDate: item.BookingDate,
        locationId: item.Availability?.Location?.LocationID,
        locationName: item.Availability?.Location?.LocationName,
        bookingDate: item.BookingDate,
        bookingTime: window.moment(item.Availability.StartTime, 'HH:mm:ss').format('HH:mm:ss'),
        bookingEndTime: window.moment(item.Availability.EndTime, 'HH:mm:ss').format('HH:mm:ss'),
        caseId: "",
        bookingId: "",
        isTentative: true,
        availabilityId: item.Availability?.AvailabilityID,
        videoLinkAvailable: item.Availability.AvailabilityOptions.VideoLinkAvailable,
        regionId: item.RegionID,
        isSingleId: true,
        isFromSpecialist: this.isFromSpecialist,
        isSupplementary: false,
        hasUserVideo: item.Availability.AvailabilityOptions.VideoLinkAvailable,
        hasVideo: item.Availability.AvailabilityOptions.VideoOnly,
        deliveryMethods: item.DeliveryMethodIDs ? item.DeliveryMethodIDs.map(i => i.DeliveryMethodID): [],
      }
      if( item.DeliveryMethodIDs && item.DeliveryMethodIDs.length > 1) {
        bookingParams.defaultDeliveryMethod = null
      } else if( item.DeliveryMethodIDs && item.DeliveryMethodIDs.length  === 1) {
        bookingParams.defaultDeliveryMethod = item.DeliveryMethodIDs[0].DeliveryMethodID
      }
      this.$store.dispatch("booking/setBookingObject", bookingParams)
      if(this.user.type >= 3) {
        this.$router.push({ name: 'admin-search-cases-details'})
      } else {
        this.$router.push({ name: 'search-cases-details'})
      }
    },
    changeDates(v) {
      if(v) {
        this.listParam.BookingDateFrom = v[0]
        this.listParam.BookingDateTo = v[1]
      } else {
        this.listParam.BookingDateFrom = null
        this.listParam.BookingDateTo = null
      }
      this.selectPage(1)
    },
    sortParam( v ) {
      this.listParam.orderBy = v.prop
      if(v.order === "ascending") {
        this.listParam.ascOrDesc = 'ASC'
      } else if (v.order === "descending") {
        this.listParam.ascOrDesc = 'DESC'
      } else {
        this.listParam.orderBy = null
        this.listParam.ascOrDesc = null
      }

      this.selectPage(1)
    },
    getStatus(status) {
      if(status === 0) {
        return 'On Hold'
      } else if (status === 1) {
        return 'Booked'
      } else if (status === 2) {
        return 'Released'
      } else if (status === 3) {
        return 'Expired'
      } else if (status === 4) {
        return 'Hold Extended'
      }
    },
    getFullPhoneEmail(phone, email) {
      let fullPhoneEmail = phone + (phone !== '' && email !== '' ? " / " : "") + email
      return fullPhoneEmail
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadBookings()
    },
    formatDate(dateToFormat, newFormat, currentFormat = "") {
      return utilities.formatDate(dateToFormat, newFormat, currentFormat)
    },

    async loadBookings() {
      await this.$store.dispatch("loading/setLoadComponent", true)
      let obj = {...this.listParam}
      for (let key in obj) {
        if (obj[key] === null || obj[key] === '') {
          delete obj[key];
        }
      }
      const {data, total} = await utilities.getTentativeBooking(obj)
      this.bookings = _.cloneDeep(data)
      this.totalCount = total
      await this.$store.dispatch("loading/setLoadComponent", false)
    },
  },
  async beforeMount() {
    $('body>.tooltip').remove()
    await this.loadBookings()
  },
  mounted() {
    $(".pagination").hide()
  },
}
</script>
